import name from './name'

const selectSliceData = state => state[name]

const selectClientInfo = state => selectSliceData(state).info

const selectClientList = state => selectSliceData(state).clientList

export { selectClientInfo, selectClientList }
